import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/product-locations', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/product-locations', {
      location_id: data.location_id,
      product_id: data.seletedProductIds
    })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/product-locations/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const warehouse = (Options = {}) => {
  return httpClient
    .get('/api/product-locations/warehouses', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const product = (location_id, Options = {}) => {
  return httpClient
    .get(`/api/product-locations/${location_id}/products`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  destroy,
  warehouse,
  product
}
